<div class="px-1">
  <div class="d-flex align-items-center justify-content-between top-container">
    <div class="main-title">
      {{ 'tooltip.pref_score.break_down' | translate }}
    </div>
    <wilson-score-display
      [score]="prefScores[ShiftScoreName.ShiftPreferenceScore]"
    ></wilson-score-display>
  </div>

  @if (prefScores[ShiftScoreName.ShiftWorkTimePreferenceScore]) {
    <div class="mt-1 mb-1 d-flex align-items-center justify-content-between">
      <div class="score-title">
        {{
          'tooltip.pref_score.break_down.shift_work_time_preference' | translate
        }}
      </div>
      <wilson-score-display
        [score]="prefScores[ShiftScoreName.ShiftWorkTimePreferenceScore]"
      ></wilson-score-display>
    </div>
  }

  @if (prefScores[ShiftScoreName.ShiftLocationPreferenceScore]) {
    <div class="mt-1 mb-1 d-flex align-items-center justify-content-between">
      <div class="score-title">
        {{ 'page.accounts.location_preferences' | translate }}
      </div>
      <wilson-score-display
        [score]="prefScores[ShiftScoreName.ShiftLocationPreferenceScore]"
      ></wilson-score-display>
    </div>
  }

  @if (prefScores[ShiftScoreName.ShiftVehiclePreferenceScore]) {
    <div class="mt-1 mb-1 d-flex align-items-center justify-content-between">
      <div class="score-title">
        {{ 'page.accounts.vehicle_preferences' | translate }}
      </div>
      <wilson-score-display
        [score]="prefScores[ShiftScoreName.ShiftVehiclePreferenceScore]"
      ></wilson-score-display>
    </div>
  }

  @if (prefScores[ShiftScoreName.ShiftEndAtHomePreferenceScore]) {
    <div class="mt-1 mb-1 d-flex align-items-center justify-content-between">
      <div class="score-title">
        {{ 'tooltip.pref_score.break_down.end_shift_at_home' | translate }}
      </div>
      <wilson-score-display
        [score]="prefScores[ShiftScoreName.ShiftEndAtHomePreferenceScore]"
      ></wilson-score-display>
    </div>
  }

  @if (prefScores[ShiftScoreName.CompanyShiftTimePreferenceScore]) {
    <div class="mt-1 mb-1 d-flex align-items-center justify-content-between">
      <div class="score-title">
        {{ 'tooltip.pref_score.break_down.time_preferences' | translate }}
      </div>
      <wilson-score-display
        [score]="prefScores[ShiftScoreName.CompanyShiftTimePreferenceScore]"
      ></wilson-score-display>
    </div>
  }

  @if (
    (isLongShiftPrefEnabled$ | async) &&
    prefScores[ShiftScoreName.LongShiftPreferenceScore] !== null &&
    prefScores[ShiftScoreName.LongShiftPreferenceScore] !== undefined
  ) {
    <div class="mt-1 mb-1 d-flex align-items-center justify-content-between">
      <div class="score-title">
        {{ 'tooltip.pref_score.break_down.long_shift_preference' | translate }}
      </div>
      <wilson-score-display
        [score]="prefScores[ShiftScoreName.LongShiftPreferenceScore]"
      ></wilson-score-display>
    </div>
  }
</div>
